import React, { useState, useEffect, FC, useRef } from 'react';
import './other-table-row.scss';
import StockTableCountCell, { StockDestination } from '../stock-table-count-cell/stock-table-count-cell';
import { Checkbox } from 'primereact/checkbox';
import { ProductType } from '../other-table/other-table';
import { Chip } from 'primereact/chip';
import { updateOPProductsByShop } from '../../productSlices';
import { useDispatch, useSelector } from 'react-redux';
import { ContextMenu } from 'primereact/contextmenu';

export interface OtherTableRowProps {
    id: string;
    name: string;
    type: ProductType;
    total: number;
    pack_count: number;
    pack_size: number;
    total_quantity: number;
    checked: boolean;
    setChecked: (checked: boolean, id: string) => void;
    setProductIdToDelete: Function;
    setWordToConfirm: Function;
    setProductToEdit: Function;
    handleStockModify: (id: string, propertyName: string, value: number, destinationShop: string, destination: string) => void;
    destination: string;
}
export const typeIdToLabel = {
    1: 'Food',
    2: 'Other'
}
const OtherTableRow:FC<OtherTableRowProps> = (props) => {
    const dispatch: Function = useDispatch();
    const selectedShop = useSelector((state: any) => state.user.selectedShop);
    const cm = useRef(null);
    const user = useSelector((state: any) => state.auth.user);
    const userAllowedToEdit = user.roleLevel >= 2;
    const [destinationShop, setDestinationShop] = useState(null);
    const items = [
        { label: 'Edit', icon: 'pi pi-user-edit', command:()=>props.setProductToEdit({id: props.id, name: props.name, type: props.type, pack_size: props.pack_size, total_quantity: props.total_quantity, pack_count: props.pack_count})},
        { label: 'Delete', icon: 'pi pi-trash', command: ()=>{props.setProductIdToDelete(props.id);props.setWordToConfirm(props.name)} }
    ];
    const handleUpdateStock = (propertyName, value, destination) => {
        const newStock = {...props, [propertyName]: value, checked: undefined, setChecked: undefined, destination_shop_id: destination === StockDestination.OtherShop ? destinationShop : undefined, has_been_consumed: !(destination === StockDestination.Trash), destination: destination}
        dispatch(updateOPProductsByShop(selectedShop,newStock.id, newStock))
        setDestinationShop(null);
    }
    return (
        <div className="stock-table-row" onContextMenu={(e) => {userAllowedToEdit ? cm.current.show(e): e.preventDefault()}}>
            <Checkbox onChange={e => props.setChecked(e.checked, props.id)} checked={props.checked}></Checkbox>
            <div className="stock-table-row__label">{props.name}</div>
            <Chip label={typeIdToLabel[props.type]} className={typeIdToLabel[props.type]} />
            <StockTableCountCell stock={props.total_quantity}  externalDestination={props.destination} originalValue={props.total_quantity} setStock={(c, _, destination) => handleUpdateStock('total_quantity', c, destination)} destinationShop={destinationShop} setDestinationShop={(c) => setDestinationShop(c)} handleStockModify={(count, destinationShop, destination) => props.handleStockModify(props.id, 'total_quantity', count, destinationShop, destination)}  />
            <StockTableCountCell transfer={true}  externalDestination={props.destination} stock={props.pack_count} originalValue={props.pack_count} setStock={(c, _, destination) => handleUpdateStock('pack_count', c, destination)} destinationShop={destinationShop} setDestinationShop={(c) => setDestinationShop(c)} handleStockModify={(count, destinationShop, destination) => props.handleStockModify(props.id, 'pack_count', count, destinationShop, destination)} />
            <div className="stock-table-row__label">{props.pack_size}</div>
            {userAllowedToEdit && <ContextMenu model={items} ref={cm} breakpoint="767px" /> }
        </div>
    );
}
         
export default OtherTableRow;